<template>
    <div class="flex flex-col items-center">
        <transition mode="out-in">
            <QuestionInputs
                v-if="!interruptionShow"
                :title="$root.data.questionTextSleep"
                :values="$root.config.quiz.sleep"
                :flex-config="{mobile: {gap: '0.5625rem'}, desktop: {cols: 1, maxWidth: '32.625rem'}}"
                @value-changed="handleNext"
            />
            <Interruption
                v-else-if="interruptionContent && interruptionShow"
                :config="{content: interruptionContent}"
                @goToNext="goToNext"
            />
        </transition>
    </div>
</template>

<script>
    import QuestionInputs from '@/apps/quiz/components/QuestionInputs.vue';
    import Interruption from '@/apps/quiz/components/Interruption.vue';

    export default {
        components: {
            QuestionInputs,
            Interruption
        },
        data() {
            return {
                interruptionShow: false,
                interruptionInstance: null,
                interruptionContent: null,
                value: null
            };
        },
        methods: {
            handleNext (value) {
                this.value = value;
                this.interruptionInstance = this.$root.config.quiz.sleep.find(answer => answer.id === this.value).interruption;

                if (this.interruptionInstance !== 'undefined' || this.interruptionInstance !== null) {
                    this.interruptionContent = this.interruptionInstance;
                }

                setTimeout(() => {
                    if (this.interruptionContent) {
                        this.interruptionShow = true;
                        window.innerWidth < 1024 ? window.scrollTo(0, 0) : document.querySelector('.js-route-content-container').scrollTo(0, 0);
                    } else {
                        this.goToNext();                        
                    }
                }, 300);
            },
            goToNext () {
                this.$router.push({
                    name: 'Stress',
                    params: {
                        sleep: this.value
                    }
                });
            }
        }
    };
</script>

<style scoped>
    .v-enter-active,
    .v-leave-active {
        transition: all 0.3s ease-out;
    }

    .v-enter-from,
    .v-leave-to {
        @apply opacity-0;
    }
</style>
